import { Avatar, AvatarFallback } from "./avatar"
import { User } from "@promo/shared"
import { getUserInitials } from "@promo/shared"
import { cn } from "@/lib/utils"

interface UserAvatarProps {
  user?: User | null | undefined
  initials?: string
  className?: string
  "data-testid"?: string
}

export function UserAvatar({ user, initials, className, "data-testid": dataTestId }: UserAvatarProps) {
  const displayInitials = initials || (user ? getUserInitials(user) : '??');
  
  return (
    <Avatar className={cn("bg-gray-700", className)} data-testid={dataTestId}>
      <AvatarFallback className="bg-gray-700 text-white">
        {displayInitials}
      </AvatarFallback>
    </Avatar>
  )
} 